import { render, staticRenderFns } from "./Documentation.vue?vue&type=template&id=44c47568&"
import script from "./Documentation.vue?vue&type=script&lang=ts&"
export * from "./Documentation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports